export const appointmentMode = {
    DELIVERY: 1,
    DISPOSAL: 2
}

export const carRegistrationDocument = {
    with: 34,
    without: null
}

export const registration = {
    with: 33,
    without: null
}

export const paymentMode = {
    BANK_CHECK_PAYMENT_MODE: 1,
    TRANSFER_PAYMENT_MODE: 2,
    CREDIT_PAYMENT_MODE_MOBILIZE: 3,
    CREDIT_PAYMENT_MODE_COFIDIS: 4,
    CREDIT_PAYMENT_MODE_YOUNITED: 5
}

